<section class="section1">
  <div class="main-logo text-center" data-aos="fade-down" data-aos-delay="1000">
    <img
      src="{{ onPassiveBaseUrl }}onpassive-october/images/logo.png"
      class="img-fluid"
      width="220"
      alt="logo"
    />
  </div>

  <div class="container">
    <div class="row whole-row align-items-center">
      <div
        class="col-lg-4 marginTop whole-rotate-img order-lg-2"
        data-aos="zoom-in"
      >
        <div class="blink"></div>
        <div class="image-rotate-frst">
          <img
            src="{{ onPassiveBaseUrl }}onpassive-october/images/rotate.png"
            alt="rotate"
            class="img-fluid"
          />
        </div>
        <div class="image-rotate-scnd">
          <img
            src="{{ onPassiveBaseUrl }}onpassive-october/images/rotate.png"
            alt="rotate"
            class="img-fluid"
          />
        </div>
        <div class="contents-in-img">
          <h3 data-shadow="NEW REVOLUTIONIZED">NEW REVOLUTIONIZED</h3>
          <h4>
            INTERNET<br />
            MARKETING SOLUTIONS
          </h4>
          <a
            href="/registration/user?reg={{ userId }}"
            class="btn-founder"
            name="regform"
            target="_blank"
            rel="noopener"
            >BECOME A FOUNDER NOW</a
          >
        </div>
        <div class="blink1"></div>
      </div>

      <div
        class="col-lg-4 content-left order-lg-1"
        data-aos="fade-right"
        data-aos-delay="200"
      >
        <h2 class="anim">LAUNCHING SOON!</h2>
        <div class="underline anim"></div>

        <p class="text-white split">
          What is it that one thing which you have always wished for? A happy
          family, travelling around the world, getting financial freedom...
          Whatever it is, ONPASSIVE is the only magical wand that will make your
          dreams come true. Generate a lifetime of residual income with this
          fully automated and hands-free earning platform
        </p>
      </div>

      <div
        class="col-lg-4 order-lg-3"
        data-aos="fade-left"
        data-aos-delay="200"
      >
        <div class="video-box">
          <video
            id="my-video"
            class="video-js video-size w-100 h-auto"
            controls
            preload="auto"
            poster="{{ myLinksS3URL }}images/Image0231.png"
            data-setup="{}"
            autoplay="true"
            muted
          >
            <source
              src="{{ myLinksS3URL }}videos/Onpassive_launching_page_video.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </div>
  </div>
</section>
